import styled from 'styled-components';

export const AudienceInsightsStyles = styled.section``;
